import React from "react";
import ServiceCard from "./service-card";
import { Box } from "@mui/material";

const Services = ({ data }) => {
  return (
    <Box sx={{ p: 3 }} className="flex flex-col w-full gap-5">
      {data?.length === 0 ? (
        <div className="text-start">There are no Service yet</div>
      ) : (
        data?.map((item, idx) => {
          return (
            <div key={idx}>

              <ServiceCard data={item} />

            </div>
          );
        })
      )}
    </Box>
  );
};

export default Services;
